import { ReactNode, Suspense, lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AccessDeniedPermission from '@/feature/access-denied-permission/pages/AccessDeniedPermission';
import { useUser } from '../contexts/UserContext';
import { isTenantRouteScope } from './routeScope';
import { createLoginPathWithReturnTo } from '@/feature/auth/utils/authRouting';

const SignInPage = lazy(() => import('@/feature/auth/pages/SignIn'));

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermission?: string;
}

const ProtectedRoute = ({
  children,
  requiredPermission
}: ProtectedRouteProps) => {
  const { user, accessToken, permissions } = useUser();
  const location = useLocation();

  if (!user && !accessToken) {
    if (isTenantRouteScope() && location.pathname.startsWith('/admin')) {
      return (
        <Suspense fallback={null}>
          <SignInPage />
        </Suspense>
      );
    }

    return (
      <Navigate
        to={createLoginPathWithReturnTo(
          `${location.pathname}${location.search}${location.hash}`
        )}
        replace
      />
    );
  }

  if (requiredPermission && !permissions?.includes(requiredPermission)) {
    return <AccessDeniedPermission />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
